import React from "react"

import { Skeleton } from "../Skeleton"

type DoughnutChartSilhouetteProps = {
  height: number
}

const DoughnutChartSilhouette: React.FC<DoughnutChartSilhouetteProps> = ({ height }) => {
  const adjustedSize = Math.max(height - 60, 70) // Adjust size to ensure it fits within the Skeleton
  return (
    <Skeleton className={`w-full h-[${height}px] p-5 flex flex-col`}>
      <div className="min-h-5 rounded-full bg-gray-300 max-w-[140px] mb-2"></div>

      <div className="flex items-center justify-between h-full">
        <div className="flex flex-col w-[40%] pr-[20px] h-full justify-center gap-4">
          {[...Array(2)].map((_, index) => (
            <div key={`block-row-${index}`} className="flex gap-2 items-center">
              <div className="h-4 aspect-square rounded-full bg-gray-300"></div>
              <div className="h-4 rounded-full bg-gray-300 w-full"></div>
            </div>
          ))}
        </div>

        <div className="grow flex items-center justify-center max-w-[60%]">
          <svg
            width={adjustedSize}
            height={adjustedSize}
            viewBox="0 0 114 114"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M57,57 L57,0 A57,57 0 0,1 114,57 Z"
              fill="#D1D5DB"
              stroke="#E5E7EB"
              strokeWidth={2}
            />
            <path
              d="M57,57 L114,57 A57,57 0 0,1 57,114 Z"
              fill="#D1D5DB"
              stroke="#E5E7EB"
              strokeWidth={2}
            />
            <path
              d="M57,57 L57,114 A57,57 0 0,1 0,57 Z"
              fill="#D1D5DB"
              stroke="#E5E7EB"
              strokeWidth={2}
            />
            <path
              d="M57,57 L0,57 A57,57 0 0,1 57,0 Z"
              fill="#D1D5DB"
              stroke="#E5E7EB"
              strokeWidth={2}
            />
            <circle cx="57" cy="57" r="40.5" fill="#E5E7EB" />
          </svg>
        </div>
      </div>
    </Skeleton>
  )
}

export default DoughnutChartSilhouette
